import { type ResolvedContextData } from '@common/defaults/ContextData';
import { LikeIcon } from '@common/svg/icons/components/LikeIcon';
import { WidgetType } from '@common/types/Sidebar';
import { type SimpleCommentProps } from '@common/types/SimpleCommentProps';
import { getT, Ns } from '@web/i18n';
import { SimpleComment } from '@web/molecules/SimpleComment';
import { SimpleCommentList } from '@web/molecules/SimpleComment/SimpleCommentList';
import { SimpleWidget } from '@web/organisms/SimpleWidget';
import { type SimpleWidgetConfig } from '@web/organisms/SimpleWidget/SimpleWidget.types';

interface Props {
    contextData: ResolvedContextData;
    dataList?: SimpleCommentProps[];
}

export const widgetConfig: SimpleWidgetConfig = {
    title: 'popular-comments.title',
    type: WidgetType.MOST_LIKED_COMMENTS,
};

export const Widget = ({ contextData, dataList }: Props) => {
    const __sidebar = getT(contextData.context.locale, Ns.Sidebar);
    const title = __sidebar(widgetConfig.title);
    const metaSuffix = __sidebar('popular-comments.count');
    return (
        <SimpleWidget contextData={contextData} title={title}>
            <SimpleCommentList>
                {dataList?.map((data, i) => (
                    <SimpleComment key={i} metaSuffix={metaSuffix} metaIcon={<LikeIcon />} {...data} />
                ))}
            </SimpleCommentList>
        </SimpleWidget>
    );
};
